import { z } from 'zod';

export const FORM_SCHEMA = z.object({
  id: z.string().min(1, 'ID is required.'),
  isEnabled: z.boolean(),
  isAddedToDoLater: z.boolean().default(false)
});

/** @type {z.infer<typeof FORM_SCHEMA>} */
export const DEFAULT_FORM_DATA = {
  id: '',
  isEnabled: false,
  isAddedToDoLater: false
};
